import { translateText } from "infra/translation/translate";
import EmployeeGrid from "presentation/components/Employee/EmployeeGrid";
import FunctionHeader from "presentation/components/Header/FunctionHeader";
import Spinner from "presentation/components/Shared/Spinner";
import usePermissionCheck from "presentation/hooks/use-check-permissions";

const EmployeeGridPage = () => {
  const { isLoading } = usePermissionCheck({ requiredFunction: "employees" });

  if (isLoading) {
    return <Spinner />;
  }
  return (
    <div>
      <FunctionHeader title={translateText("Employees", "pt")} />
      <EmployeeGrid />
    </div>
  );
};

export default EmployeeGridPage;
